import React from 'react';
import StyledButton from 'common/StyledButton';
import Footer from 'common/Footer';
import PropTypes from 'prop-types';
import css from './ProfileFooter.scss';

/*
  Creates a Sticky footer for Profile page with two buttons named, Save Changes and Cancel.
*/
function ProfileFooter({ disableSave, onCancel, onSave, saving }) {
    return (
        <Footer
            primaryButton={
                <StyledButton className={css['footer-button']}
                              disabled={disableSave || saving}
                              onClick={onSave}>
                    {saving ? 'Saving...' : 'Save Changes'}
                </StyledButton>
            }
            secondaryButton={
                <StyledButton asLink
                              className={css['footer-button']}
                              onClick={onCancel}>
                    Clear Changes
                </StyledButton>
            }
        />
    );
}

ProfileFooter.defaultProps = {
    disableSave: false,
    saving: false
};

ProfileFooter.propTypes = {
    disableSave: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    saving: PropTypes.bool
};

export default ProfileFooter;
